<template>
  <div class="w-full grid grid-flow-col grid-cols-13 gap-x-6 items-center py-6">
    <Input
      v-model="search"
      placeholder="Search by keywords"
      class="col-start-1 col-end-2"
    />
    <Select
      v-model="industry"
      placeholder="Industry"
      class="col-start-2 col-end-3"
      :options="industries"
    />

    <Select
      v-model="country"
      placeholder="Country"
      class="col-start-3 col-end-4"
      :options="ugc_countries"
    />
    <Select
      v-model="gender"
      placeholder="Gender"
      class="col-start-4 col-end-5"
      :options="genders"
    />

    <div class="col-start-1 col-end-14 pt-4 flex text-base">
      <template
        v-for="(value, name) in {
          industry,
          country,
          gender
        }"
        :key="`filter${value}`"
      >
        <span
          class="filters__item"
          v-if="value"
          @click="removeFilterOption(name)"
        >
          <Icon name="Check" class="check w-4 h-4 mr-2" />
          <Icon name="Close" class="close w-4 h-4 mr-2" />
          {{ value }}
        </span>
      </template>
      <span
        class="filters__item"
        @click="resetFilters"
        v-if="industry || type || objective || format"
      >
        <Icon name="Refresh" class="refresh w-4 h-4 mr-2" />Reset All
      </span>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import Input from "@/components/UI/Input";
import Select from "@/components/UI/Select/index";
import Icon from "@/components/UI/Icon";

export default {
  components: { Input, Select, Icon },
  setup() {
    const store = useStore();

    const search = ref("");
    const gender = ref("");
    const industry = ref("");
    const country = ref("");

    const industries = computed(() => store.state.industries);
    const ugc_countries = computed(() => store.state.ugc_countries);
    const genders = computed(() => store.state.genders);
    watch(
      [search],
      debounce(() => {
        getUgcCreators();
      }, 1500)
    );

    watch([industry, country, gender], () => {
      if (industry.value || country.value || gender.value) getUgcCreators();
    });

    const getUgcCreators = () => {
      store.commit("SET_PAGE", 0);
      store.commit("SET_UGC_CREATORS", null);
      store.dispatch("GET_UGC_CREATORS", {
        search: search.value ? search.value : undefined,
        industry: industry.value ? industry.value : undefined,
        country: country.value ? country.value : undefined,
        gender: gender.value ? gender.value : undefined,
      });
    };

    const resetFilters = () => {
      search.value = null;
      industry.value = null;
      country.value = null;
      gender.value = null;

      store.commit("SET_FILTERS", {});
      store.commit("SET_PAGE", 0);
      store.commit("SET_UGC_CREATORS", null);
      store.dispatch("GET_UGC_CREATORS");
    };

    const removeFilterOption = (name) => {
      switch (name) {
        case "industry":
          industry.value = null;
          break;
        case "country":
          country.value = null;
          break;
        case "gender":
          gender.value = null;
          break;

        default:
          break;
      }
    };

    return {
      search,
      industry,
      country,
      ugc_countries,
      genders,
      gender,
      industries,
      getUgcCreators,
      resetFilters,
      removeFilterOption,
    };
  },
};
</script>

<style scoped>
.filters__item {
  @apply flex border-r border-gray-600 py-0 px-3 mr-2 cursor-pointer;
}
.filters__item svg {
  transition: 0.3s;
}
.filters__item:hover .check,
.filters__item .close {
  display: none;
}
.filters__item:hover .close {
  display: block;
}
.filters__item:hover .refresh {
  transform: rotate(60deg);
}
</style>
